export default __webpack_public_path__ + "images/OC.be4c89a.png";